module.exports = __webpack_public_path__ + "img/pioneer-logo.805db448.svg";